import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var Sticker = function Sticker(_ref) {
  var children = _ref.children,
    icon = _ref.icon;
  return React.createElement(React.Fragment, null, icon && React.createElement(FontAwesomeIcon, {
    icon: icon
  }), children && icon ? React.createElement('span', {
    className: 'd-none d-md-inline ml-2'
  }, children) : children);
};
Sticker.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.string
};
Sticker.defaultProps = {
  icon: undefined
};
export default Sticker;